module.exports = __webpack_public_path__ + "static/img/2.88fed92d.jpg";